import OffTwoFactorAuth from './OffTwoFactorAuth';
export default OffTwoFactorAuth;
